var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"chat-page"},[_c('el-container',{staticClass:"chat-box"},[(_vm.isPCTerminalChat)?_c('container-manager'):_vm._e(),(_vm.chatStore.activeChat && !_vm.isAIChat)?_c('chat-box',{attrs:{"chat":_vm.chatStore.activeChat}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }